import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Info() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-5" variant="h5" component="h2">
            関連会社役員の新型コロナウイルス感染について（３月２３日）
          </Typography>
          　本日、デーリー東北販売株式会社（八戸市）の６０代男性役員１名の新型コロナウイルス感染が判明しました。<br />
          <br />
          　当該役員は、２１日にのどの痛みを覚え、翌２２日に八戸市内の医療機関を受診し PCR検査を受け、同日夜に陽性が確認されました。当該役員は、３月１９日から休日で出社しておらず、保健所によると同居家族以外に濃厚接触者はいません。<br />
          <br />
          　当社では、関係各所の皆さまと従業員の安全を最優先に考え、所管保健所等と連携を図り、感染拡大防止のため必要な対策を適正に講じてまいります。皆様のご理解とご協力を賜りますようお願い申し上げます。<br />
          <br />
          <div className="text-right mt-5">
            【お問い合わせ先】<br />
            デーリー東北新聞社 企画総務局総務部<br />
            電話　０１７８（４４）５１１１<br />
          </div>
        </Box>
        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-5" variant="h5" component="h2">
            本社従業員の新型コロナウイルス感染について（３月１０日）
          </Typography>
          　本日、本社（八戸市）に勤務する３０代女性従業員１名の新型コロナウイルス感染が判明しました。<br />
          <br />
          　当該従業員は、７日に感染が確認された本社に勤務する４０代男性従業員と同居する家族で、８日に八戸市内の医療機関を受診しPCR検査を受け、１０日に陽性が確認されました。当該従業員は、６日から自宅待機しています。<br />
          <br />
          　当社では、関係各所の皆さまと従業員の安全を最優先に考え、所管保健所等と連携を図り、感染拡大防止のため必要な対策を適正に講じてまいります。皆様のご理解とご協力を賜りますようお願い申し上げます。<br />
          <br />
          <div className="text-right mt-5">
            【お問い合わせ先】<br />
            デーリー東北新聞社 企画総務局総務部<br />
            電話　０１７８（４４）５１１１<br />
          </div>
        </Box>
        */}
        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-5" variant="h5" component="h2">
            本社従業員の新型コロナウイルス感染について（３月９日）
          </Typography>
          　本日、本社（八戸市）に勤務する４０代女性従業員１名の新型コロナウイルス感染が判明しました。<br />
          <br />
          　当該従業員は、２日に同居する家族の感染が確認され、その濃厚接触者に該当すると判断されたため、６日に八戸市内の医療機関を受診しPCR検査を受け、８日夜に陽性が確認されました。当該従業員は、２日から自宅待機しています。<br />
          <br />
          　なお、７日に陽性が確認された当社４０代男性従業員とは職場が異なり、最近の接触はありませんでした。<br />
          <br />
          　当社では、関係各所の皆さまと従業員の安全を最優先に考え、所管保健所等と連携を図り、感染拡大防止のため必要な対策を適正に講じてまいります。皆様のご理解とご協力を賜りますようお願い申し上げます。<br />
          <br />
          <div className="text-right mt-5">
            【お問い合わせ先】<br />
            デーリー東北新聞社 企画総務局総務部<br />
            電話　０１７８（４４）５１１１<br />
          </div>
        </Box>
        */}
        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-5" variant="h5" component="h2">
            本社従業員の新型コロナウイルス感染について（３月７日）
          </Typography>
          　本日、本社（八戸市）に勤務する４０代男性従業員１名の新型コロナウイルス感染が判明しました。<br />
          <br />
          　当該従業員は、６日に発熱、同日に八戸市内の医療機関を受診しPCR検査を受け、７日陽性が確認されました。保健所の指導の下、感染経路および濃厚接触者の特定を進めているところです。<br />
          <br />
          　当社では、関係各所の皆さまと従業員の安全を最優先に考え、所管保健所等と連携を図り、感染拡大防止のため必要な対策を適正に講じてまいります。皆様のご理解とご協力を賜りますようお願い申し上げます。<br />
          <br />
          <div className="text-right mt-5">
            【お問い合わせ先】<br />
            デーリー東北新聞社 企画総務局総務部<br />
            電話　０１７８（４４）５１１１<br />
          </div>
        </Box>
        */}
      </div>
    </div>
  );
}

export default Info;
